import { IconWrapper } from '../runtime';
export default IconWrapper('wechat-sharing-one', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "fill": "none",
      "height": props.size,
      "viewBox": "0 0 48 48",
      "width": props.size
    }
  }, [h("linearGradient", {
    "attrs": {
      "id": props.id + 'b1719fd1',
      "gradientUnits": "userSpaceOnUse",
      "x1": "-24",
      "x2": "24",
      "y1": "24",
      "y2": "72"
    }
  }, [h("stop", {
    "attrs": {
      "offset": "0",
      "stop-color": "#5dda81"
    }
  }), h("stop", {
    "attrs": {
      "offset": "1",
      "stop-color": "#2ab67b"
    }
  })]), h("clipPath", {
    "attrs": {
      "id": props.id + 'a9168637'
    }
  }, [h("path", {
    "attrs": {
      "d": "m0 0h48v48h-48z"
    }
  })]), h("g", {
    "attrs": {
      "clip-path": 'url(#' + props.id + 'a9168637' + ')'
    }
  }, [h("path", {
    "attrs": {
      "d": "m48 24c0 13.2555-10.7445 24-24 24s-24-10.7445-24-24 10.7445-24 24-24 24 10.7445 24 24z",
      "fill": 'url(#' + props.id + 'b1719fd1' + ')'
    }
  }), h("path", {
    "attrs": {
      "d": "m16.4355 19.113c-.7545 0-1.365-.618-1.365-1.3815s.6105-1.3815 1.365-1.3815c.753 0 1.365.618 1.365 1.3815s-.612 1.3815-1.365 1.3815zm8.442-2.763c.7545 0 1.365.618 1.365 1.3815s-.6105 1.3815-1.365 1.3815-1.365-.618-1.365-1.3815.6105-1.3815 1.365-1.3815zm6.018 2.5395c-1.125-3.957-5.1945-6.8895-10.0425-6.8895-5.718 0-10.353 4.0755-10.353 9.1035 0 2.85 1.488 5.394 3.819 7.062.399.2865-.99 2.346-.99 2.346s3.2655-1.092 3.8025-.9105c1.0356.3449 2.1148.5418 3.2055.585-.1404-.6344-.2113-1.2822-.2115-1.932 0-5.2965 4.7745-9.2775 10.77-9.3675zm3.0915 7.482c-.636 0-1.152-.522-1.152-1.1655s.516-1.167 1.152-1.167 1.152.522 1.152 1.167-.516 1.1655-1.152 1.1655zm-7.131 0c-.636 0-1.152-.522-1.152-1.1655s.516-1.167 1.152-1.167 1.1535.522 1.1535 1.167-.516 1.1655-1.1535 1.1655zm12.144 1.6815c0-4.2465-3.915-7.689-8.7435-7.689s-8.745 3.4425-8.745 7.689 3.915 7.6905 8.745 7.6905c1.107 0 2.1675-.1815 3.1425-.5115.4545-.1545 3.2115.768 3.2115.768s-1.173-1.74-.8355-1.9815c1.968-1.41 3.225-3.558 3.225-5.9655z",
      "fill": "#fff"
    }
  })])]);
});